<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog attach v-model="modalOpen" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="group" lazy-validation>
            <v-layout wrap align-center justify-center>
              <v-flex xs12>
                <v-text-field required
                  :rules="[$rules.empty('Grup Adı')]"
                  @keydown.enter="save"
                  v-model="originalData.name" label="Kayıt Adı">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="modalOpen = !modalOpen">İptal</v-btn>
        <v-btn
          color="blue darken-1"
          text @click="save">
            Kaydet
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';

export default {
  name: 'GroupModal',
  data: () => ({
    data: {},
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    async save() {
      if (this.$refs.group.validate()) {
        this.send({
          route: this.route,
          data: this.originalData,
        })
          .then(async () => {
            this.$trigger('onload:load');
            this.modalOpen = !this.modalOpen;
          });
      }
    },
  },
  computed: {
    isNotEdited() {
      return this.editedIndex === -1;
    },
    formTitle() {
      return this.isNotEdited ? 'Yeni Kayıt' : 'Kaydı Güncelle';
    },
    originalData() {
      return this.isNotEdited ? this.data : this.modalData;
    },
    route() {
      return this.isNotEdited ? 'add/group' : 'update/group';
    },
    ...mapFields({
      modalOpen: 'modal.open',
      modalData: 'modal.editedData',
      editedIndex: 'modal.index',
    }),
  },
};
</script>
